import React, { lazy, Suspense } from "react";
import { LoadingProgressBar } from "@rentablo/components";
import { CashbackWizardStart as NewCashbackWizardStart } from "@features/cashbackWizard2.0/CashbackWizardStart.tsx";
import { CashbackImportPage } from "@features/cashbackImport/CashbackImportPage.tsx";
import { CashbackDashboardEditContactPage } from "@features/cashback/contact/edit/CashbackDashboardEditContactPage.tsx";
import { CashbackDashboardRecommendPage } from "@features/cashback/invite-friend/CashbackDashboardRecommendPage.tsx";
import CashbackDashboardPage from "@features/cashback/CashbackDashboardPage.tsx";
import { Outlet } from "react-router";
import { WithAppLayout, WithFeatureFlagRoute } from "../routes.tsx";

const CashbackWizardNew = lazy(() =>
  import("@features/cashbackWizard2.0/CashbackWizardNew.tsx").then(
    (module) => ({ default: module.CashbackWizardNew })
  )
);
const CashbackWizardEdit = lazy(() =>
  import("@features/cashbackWizard2.0/CahbackWizardEdit.tsx").then(
    (module) => ({ default: module.CashbackWizardEdit })
  )
);

export default [
  {
    path: "/",
    element: (
      <WithFeatureFlagRoute featureFlag="CASHBACK_WIZARD">
        <Outlet />
      </WithFeatureFlagRoute>
    ),
    children: [
      {
        path: "/",
        element: (
          <WithAppLayout>
            <Outlet />
          </WithAppLayout>
        ),
        children: [
          {
            path: "cashback-import",
            element: <CashbackImportPage />,
          },
          {
            path: "cashback",
            children: [
              {
                path: "contact/edit/:id",
                element: <CashbackDashboardEditContactPage />,
              },
              {
                path: "invite-friend",
                element: <CashbackDashboardRecommendPage />,
              },
              {
                index: true,
                element: <CashbackDashboardPage />,
              },
            ],
          },
        ],
      },
      {
        path: "/cashback-wizard-start",
        element: <NewCashbackWizardStart />,
      },
      {
        path: "/cashback-wizard",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<LoadingProgressBar />}>
                <CashbackWizardNew />
              </Suspense>
            ),
          },
          {
            path: ":id",
            element: (
              <Suspense fallback={<LoadingProgressBar />}>
                <CashbackWizardNew />
              </Suspense>
            ),
          },
          {
            path: ":id/edit",
            element: (
              <Suspense fallback={<LoadingProgressBar />}>
                <CashbackWizardEdit />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
];
